/**
 * OV Cart Extras - add-to-cart handling for upsell offers (inline + popup +
 * PDP cross-sell) and the Inveterate membership offer. Popups show once per
 * browser session per rule. Adds made while the cart drawer is closed (e.g.
 * from a product page cross-sell) open the drawer. On the cart PAGE (no
 * drawer there) adds refresh the page content in place via the Section
 * Rendering API - full drawer/page parity, no Rebuy-style redirects.
 * Variant selects keep the offer card's thumbnail and price in sync with
 * the chosen variant. Membership adds auto-apply the first-order free
 * shipping code (MEMBER-SHIPS-FREE, US + standard rates only); the code is
 * cleared if the membership leaves the cart (detected from the rendered
 * line items). Part of the Rebuy rebuild.
 */
(function () {
  if (window.ovCartUpsellsInit) return;
  window.ovCartUpsellsInit = true;

  var FS_CODE = 'MEMBER-SHIPS-FREE';
  var MEM_VARIANTS = ['41673736454205', '41673737207869'];

  function sessionGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function sessionSet(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) { /* no-op */ }
  }

  function hasShipCode() {
    try { return document.cookie.indexOf('discount_code=' + FS_CODE) !== -1; } catch (e) { return false; }
  }

  async function applyShipCode() {
    try { await fetch('/discount/' + FS_CODE); } catch (e) { /* no-op */ }
  }

  // A membership line rendered in the cart (drawer or cart page)?
  function membershipInCartDom() {
    return MEM_VARIANTS.some(function (v) {
      return !!document.querySelector('.cart-item[data-variant-id="' + v + '"]');
    });
  }

  // If the free-shipping code was applied but the membership is no longer in
  // the cart, overwrite the discount cookie with a non-existent code so
  // checkout ignores it.
  function clearShipCodeIfOrphaned() {
    if (!hasShipCode()) return;
    if (membershipInCartDom()) return;
    // Only act on pages that render the cart contents, so we don't clear the
    // code from unrelated pages where no line items exist in the DOM.
    if (!document.getElementById('ov-cart-extras')) return;
    try { fetch('/discount/OV-NONE'); } catch (e) { /* no-op */ }
  }

  function showPopupIfNeeded() {
    const popup = document.querySelector('.ov-popup[hidden]');
    if (!popup) return;
    const handle = popup.dataset.popupHandle || 'popup';
    if (sessionGet(`ovp_${handle}`)) return;
    // Only pop when the cart drawer is open/visible, so it reads as a
    // response to the customer's add-to-cart. (On the cart page there is no
    // drawer, so a matching popup may show on load - same once-per-session.)
    const drawer = document.getElementById('cart-drawer');
    if (drawer && drawer.getAttribute('aria-hidden') === 'true') return;
    popup.hidden = false;
    sessionSet(`ovp_${handle}`, '1');
  }

  function closePopups() {
    document.querySelectorAll('.ov-popup:not([hidden])').forEach((p) => { p.hidden = true; });
  }

  // Keep an offer card's thumbnail + price in sync with its variant select.
  function syncVariantCard(sel) {
    const opt = sel.selectedOptions && sel.selectedOptions[0];
    if (!opt) return;
    const scope = sel.closest('.ov-upsell, .ov-popup-option');
    if (!scope) return;
    const img = scope.querySelector('.ov-upsell__media img, img.ov-popup-option__img');
    if (img && opt.dataset.img && img.getAttribute('src') !== opt.dataset.img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = opt.dataset.img;
    }
    const priceEl = scope.querySelector('.ov-upsell__price, .ov-popup-option__price');
    if (priceEl && opt.dataset.price) {
      if (priceEl.querySelector('.ov-popup-free')) {
        // 'Show as free' offer: keep the FREE label, update the struck price.
        priceEl.innerHTML = `<s>${opt.dataset.price}</s> <strong class="ov-popup-free">FREE</strong>`;
      } else if (opt.dataset.compare) {
        priceEl.innerHTML = `<s>${opt.dataset.compare}</s> ${opt.dataset.price}`;
      } else {
        priceEl.textContent = opt.dataset.price;
      }
    }
  }

  function syncAllVariantCards() {
    document.querySelectorAll('select.ov-popup-variant').forEach(syncVariantCard);
  }

  // --- Cart PAGE in-place refresh (Section Rendering API) -----------------
  function getElementHTML(html, selector) {
    const tmpl = document.createElement('template');
    tmpl.innerHTML = html;
    const el = tmpl.content.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function onCartPage() {
    return !document.querySelector('cart-drawer') && !!document.getElementById('cart-summary');
  }

  async function refreshCartPage() {
    const ci = document.getElementById('cart-items');
    const sectionId = ci && ci.dataset.section;
    if (!sectionId) { window.location.reload(); return; }
    const res = await fetch(`${window.location.pathname}?sections=${sectionId},cart-icon-bubble`);
    if (!res.ok) throw new Error(`Section render failed (${res.status})`);
    const sections = await res.json();
    [
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-items', section: sectionId, selector: 'cart-items' },
      { id: 'free-shipping-notice', section: sectionId, selector: '.free-shipping-notice' },
      { id: 'ov-cart-messages', section: sectionId, selector: '#ov-cart-messages' },
      { id: 'ov-cart-extras', section: sectionId, selector: '#ov-cart-extras' },
      { id: 'cart-summary', section: sectionId, selector: '.cart__summary' }
    ].forEach((target) => {
      const html = sections[target.section];
      if (!html) return;
      const sectionEl = document.getElementById(target.id);
      if (!sectionEl) return;
      const el = sectionEl.querySelector(target.selector) || sectionEl;
      el.innerHTML = getElementHTML(html, target.selector);
    });
    syncAllVariantCards();
    clearShipCodeIfOrphaned();
    showPopupIfNeeded();
  }
  // -------------------------------------------------------------------------

  document.addEventListener('change', (evt) => {
    const sel = evt.target.closest('select.ov-popup-variant');
    if (sel) syncVariantCard(sel);
  });

  document.addEventListener('click', async (evt) => {
    const closer = evt.target.closest('[data-ov-popup-close]');
    if (closer) {
      evt.preventDefault();
      closePopups();
      return;
    }

    const btn = evt.target.closest('.ov-upsell-add, .ov-membership-add');
    if (!btn || btn.disabled) return;
    evt.preventDefault();

    let variantId = btn.dataset.variantId;
    if (!variantId) {
      const scope = btn.closest('.ov-popup-option, .ov-upsell');
      const sel = scope ? scope.querySelector('.ov-popup-variant') : null;
      if (sel) variantId = sel.value;
    }
    if (!variantId) return;

    const item = {
      id: parseInt(variantId, 10),
      quantity: 1
    };
    if (btn.dataset.sellingPlan) {
      item.selling_plan = parseInt(btn.dataset.sellingPlan, 10);
    }
    const properties = {};
    if (btn.dataset.propInveterate) {
      properties._inveterate_subscription = 'true';
    }
    if (btn.dataset.freeGift) {
      properties._ov_free_gift = btn.dataset.upsellSource || 'popup';
    }
    if (btn.dataset.upsellSource) {
      properties._ov_upsell = btn.dataset.upsellSource;
    }
    if (Object.keys(properties).length) item.properties = properties;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const res = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [item] })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || `Add to cart failed (${res.status})`);
      }

      // Membership added: apply the first-order free shipping code before the
      // drawer refresh so it's in place if the customer heads to checkout.
      if (btn.dataset.propInveterate) {
        await applyShipCode();
      }

      closePopups();

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.refresh === 'function') {
        await drawer.refresh(true);
        if (drawer.getAttribute('aria-hidden') === 'true') {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
        }
      } else if (onCartPage()) {
        // Cart page: refresh line items, offers, messages and summary in
        // place - the customer stays right where they are.
        await refreshCartPage();
      } else {
        window.location.reload();
        return;
      }

      // Restore the button so it can be used again (e.g. PDP cross-sell).
      btn.textContent = originalText;
      btn.disabled = false;

      document.dispatchEvent(new CustomEvent('on:ov-upsell:added', {
        bubbles: true,
        detail: { variantId: item.id, sellingPlan: item.selling_plan || null }
      }));
    } catch (error) {
      console.log('[ov-cart-upsells]', error); // eslint-disable-line
      btn.disabled = false;
      btn.textContent = 'Try again';
      setTimeout(() => { btn.textContent = originalText; }, 2500);
    }
  });

  // Buy More Save More tier pills (snippets/ov-bmsm-pills.liquid): clicking
  // "Buy 3, Save 10%" tops the product up to 3 units by increasing the
  // clicked line's quantity by the shortfall (quantity counts across all
  // variants of the product, so other-color lines are respected). The
  // ov-engine-discounts function applies the actual percentage.
  document.addEventListener('click', async (evt) => {
    const pill = evt.target.closest('.ov-bmsm-pill');
    if (!pill || pill.disabled) return;
    evt.preventDefault();
    const target = parseInt(pill.dataset.targetQty, 10);
    const have = parseInt(pill.dataset.productQty, 10);
    const lineQty = parseInt(pill.dataset.lineQty, 10);
    const shortfall = target - have;
    if (!(shortfall > 0) || !pill.dataset.lineKey) return;
    pill.disabled = true;
    try {
      // Click-to-claim: stamp the line with _ov_bmsm = rule handle. The
      // discount function only applies BMSM to products with this claim, so
      // organic multi-quantity adds (no pill click) stay at full price.
      // change.js replaces the line's properties wholesale, so merge with
      // whatever the line already carries.
      let props = { _ov_bmsm: pill.dataset.rule || 'claimed' };
      try {
        const cartNow = await fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
        const lineNow = (cartNow.items || []).find((i) => i.key === pill.dataset.lineKey);
        if (lineNow && lineNow.properties) props = Object.assign({}, lineNow.properties, props);
      } catch (e) { /* merge is best-effort; the claim itself still lands */ }
      const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: pill.dataset.lineKey, quantity: lineQty + shortfall, properties: props })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || `Quantity update failed (${res.status})`);
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.refresh === 'function' && drawer.hasAttribute('open')) {
        await drawer.refresh(true);
      } else if (onCartPage()) {
        await refreshCartPage();
      } else if (drawer && typeof drawer.refresh === 'function') {
        await drawer.refresh(true);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.log('[ov-bmsm]', error); // eslint-disable-line
      pill.disabled = false;
    }
  });

  document.addEventListener('keyup', (evt) => {
    if (evt.key === 'Escape') closePopups();
  });

  // Cart page (and any surface using cart-items.js): re-sync after qty
  // changes/removals re-render the sections.
  document.addEventListener('on:line-item:change', () => {
    setTimeout(() => {
      syncAllVariantCards();
      clearShipCodeIfOrphaned();
      showPopupIfNeeded();
    }, 100);
  });

  const observer = new MutationObserver(() => {
    clearTimeout(window.__ovPopupTimer);
    window.__ovPopupTimer = setTimeout(() => {
      showPopupIfNeeded();
      syncAllVariantCards();
      clearShipCodeIfOrphaned();
    }, 500);
  });

  function arm() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    showPopupIfNeeded();
    syncAllVariantCards();
    clearShipCodeIfOrphaned();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
}());